<template>
  <div class="my-3">
    <div class="pb-4 border-bottom">
      <div class="row">
        <div class="col-12 col-md-4 pr-4">
          <div class="color-secondary-6 font-14 mb-1">{{ property.name }}:</div>
          <validation-observer :ref="`property-${property.id}-observer`">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                :options="availableOptions"
                fieldkey="id"
                fieldname="name"
                v-model="selected"
                placeholder="Seleccione"
                :error="errors[0]"
                custom-error-msg="Este campo es requerido"
              />
            </validation-provider>
          </validation-observer>

          <div class="d-flex justify-content-end mt-2">
            <action-button
              :variant="isMobile ? 'success w-100 mb-2' : 'success'"
              type="button"
              i="fas fa-file-plus"
              @click="add"
            >
              Añadir
            </action-button>
          </div>
        </div>
        <div class="col-12 col-md pl-4" :class="{ 'border-left': !isMobile }">
          <div class="color-secondary-6 font-14 mb-1">
            {{ property.name }}(s) Seleccionado(s):
            <div class="d-flex flex-wrap">
              <div
                class="p-2 rounded-pill detail-pill my-1 mr-2"
                v-for="(detail, index) in property.details"
                :key="index"
              >
                {{ detail.name }}

                <i
                  v-if="!detail.sealed"
                  class="far fa-times-circle pointer color-red pt-1"
                  @click="remove(index)"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import mixAlert from '@/mixins/alert.mixin';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';

export default {
  name: 'PropertySelect',
  mixins: [mixAlert],
  components: {
    CustomDropDown,
    ActionButton,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    property: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    selected: null,
  }),
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    availableOptions() {
      return this.options.filter(
        (x) => !this.property.details.map((d) => d.name).includes(x.name)
      );
    },
  },
  methods: {
    async add() {
      const observer = this.$refs[`property-${this.property.id}-observer`];
      const valid = await observer.validate();
      if (!valid) return;

      if (this.property.details.some((x) => x.name === this.selected.name)) {
        this.ShowToast(
          'Alerta',
          `La opción <b>${this.selected.name}</b> ya está en la lista de ${this.property.name}(s) Seleccionado(s).`,
          'error'
        );
        return;
      }

      this.property.details.push({
        name: this.selected.name,
        propertyId: this.property.id,
      });
      this.selected = null;
      await observer.reset();
    },
    remove(index) {
      this.property.details.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.gap-x-1 {
  gap: 0px 10px;
}
.detail-pill {
  background-color: white;
  border: 1px solid black;
  font-weight: 600;
  color: black;
}
.pointer {
  cursor: pointer;
}
</style>
